export enum NotificationTrigger {
  None = 0,
  Frequency = 1,
  MissedEntries = 2,
  DiaryResponse = 3
}
